import { render, staticRenderFns } from "./NewBook.vue?vue&type=template&id=654d37a4&scoped=true"
import script from "./NewBook.vue?vue&type=script&lang=js"
export * from "./NewBook.vue?vue&type=script&lang=js"
import style0 from "./NewBook.vue?vue&type=style&index=0&id=654d37a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654d37a4",
  null
  
)

export default component.exports